var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('McContactTable',{attrs:{"apiClient":_vm.query,"fields":_vm.fields,"hasData":_vm.hasData,"listDatas":_vm.employeesList,"withCard":false,"cardPadding":false,"hasEmptyState":false,"bulkCreate":_vm.isAdding,"dataStore":_vm.$store.state.dashboard.contactList},on:{"customTag":_vm.addTag,"updateCountryCode":_vm.updateCountryCode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }